import React from "react";

const Contact = () => {
  return (
    <div
      name="contact"
      className="w-full h-screen bg-gradient-to-b from-gray-800 to-black "
    >
      <div className="max-w-[600px] mx-auto p-4 flex flex-col justify-center w-full h-full text-white">
        <div className="pb-8 text-center space-y-3">
          <p className="text-sm inline text-[#64ffda]">04. What’s Next?</p>
          <h2 className="md:text-4xl lg:text-5xl sm:text-6xl font-bold text-[#ccd6f6] font-serif">
            Get in touch
          </h2>
          <p className="text-xl py-6">
            I’m currently looking for any new opportunities, so my inbox is
            always open. Whether you have a question or just want to say hi,
            I’ll try my best to get back to you!
          </p>
          <button className="group mb-9  w-fit px-6 py-3  text-center border border-[#64ffda] text-[#64ffda] hover:bg-[rgba(100,255,218,0.1)] cursor-pointer">
            <a href="mailto:somaptikamrunnahar@gmail.com">Say hello</a>
          </button>
          {/* <p className="stricky bottom-0 w-[600px] mx-auto p-4 text-[#64ffda]">
            <div>Designed &amp; Built by Kamrunnahar Somapti</div>
          </p> */}
        </div>
      </div>
    </div>
  );
};

export default Contact;
